<template>
  <div class="introGrid">
    <div class="content">
      <img :src="introGrid.iconUrl" alt="icon" />
      <h4>{{ introGrid.title }}</h4>
      <p>{{ introGrid.text }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from "vue";
import { IntroGrid } from "../models/IntroGrid";

export default defineComponent({
  props: {
    introGrid: {
      type: Object as PropType<IntroGrid>,
      required: true,
    },
  },
});
</script>
